
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM8.12412 9.48129C7.61765 10.2406 7.10294 10.8261 6.23824 10.8261C5.64612 10.7298 5.404 10.3065 5.53247 9.87494L6.64588 6.18471C6.67306 6.09412 6.62776 5.99776 6.54541 5.96894C6.46306 5.94012 6.30165 6.04718 6.16247 6.19953L5.48965 7.00988C5.47647 6.91103 5.48159 6.7651 5.48536 6.65771V6.65771L5.48537 6.65768C5.48678 6.61747 5.488 6.58267 5.488 6.55777C5.99365 5.79847 6.82459 5.19894 7.38788 5.19894C7.92318 5.25412 8.17682 5.68235 8.08377 6.15341L6.96212 9.85929C6.94729 9.94412 6.99176 10.0289 7.06753 10.0553C7.14988 10.0841 7.32282 9.97788 7.46282 9.82471L8.13565 9.01518C8.14791 9.10716 8.13829 9.24633 8.13079 9.35474C8.12721 9.40648 8.12412 9.45121 8.12412 9.48047V9.48129ZM7.15729 3.94141C7.15729 4.39847 7.50318 4.70812 7.92894 4.70812C8.35388 4.70812 8.69977 4.39847 8.69977 3.94141C8.69977 3.48435 8.35471 3.17388 7.92894 3.17388C7.50318 3.17388 7.15729 3.48435 7.15729 3.94141Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Tips',
    }) as DefineComponent
    </script>
    